// extracted by mini-css-extract-plugin
module.exports = {"Info":"TooltipInfo_Info__1xEZh","InfoHover":"TooltipInfo_InfoHover__2Kvpp"};